<template>
  <v-app>
    <v-container fluid fill-height elevation-0>
      <v-layout align-center justify-center mb-5 pb-5>
        <v-flex xs12 sm8 md6>
          <router-view :key="$route.fullPath"></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class LtiPage extends Vue {}
</script>

<style scoped>
.theme--light.v-application {
  background-color: #f1f1f1;
}
</style>
